import { action, thunk } from 'easy-peasy';
import {checkout, getCart, checkCoupon} from '../services/Cart';

const CartModel = {
  subdomains: [],

  showCart: action((state, cart) => {
    let subs = [];
    cart.forEach(domain => subs.push(domain.subdomain + "." + domain.domain));
    state.subdomains = subs;
  }),

  getCart: thunk(async (actions) => {
    let cart = await getCart();
    actions.showCart(cart);
  }),

  checkout: thunk(async (actions, {linkoln_subdomains, custom_domains, coupon_code}) => {
      return await checkout(linkoln_subdomains, custom_domains, coupon_code);
  }),

  checkCoupon: thunk(async (actions, coupon_code) => {
      return await checkCoupon(coupon_code);
  })
};

export default CartModel;
